export enum EAchievementUnlockedParams {
    default = 0,
    viewMedals = 1
}
